module.exports = __webpack_public_path__ + "media/src/images/icon__check--dark-a51eaa17a60cc26ab5d1afe2c8c7643e.png";